import React from 'react';
import styled from 'astroturf/react';
import routes from 'js/core_pre_webpack/routes';
import { Button } from 'js/design_system/Button';
import { Icon } from 'js/design_system/Icon';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';
import _Container from "PodcastLibraryAd2-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd2.tsx?styleId=Container";
import _ContentWrapper from "PodcastLibraryAd2-ContentWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd2.tsx?styleId=ContentWrapper";
import _TextSection from "PodcastLibraryAd2-TextSection.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd2.tsx?styleId=TextSection";
import _TitleWrapper from "PodcastLibraryAd2-TitleWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd2.tsx?styleId=TitleWrapper";
import _IconWrapper from "PodcastLibraryAd2-IconWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd2.tsx?styleId=IconWrapper";
import _Title from "PodcastLibraryAd2-Title.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd2.tsx?styleId=Title";
import _Description from "PodcastLibraryAd2-Description.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd2.tsx?styleId=Description";
import _ButtonWrapper from "PodcastLibraryAd2-ButtonWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd2.tsx?styleId=ButtonWrapper";
import _StyledButton from "PodcastLibraryAd2-StyledButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd2.tsx?styleId=StyledButton";


const Container = /*#__PURE__*/styled("a", null, {
  displayName: "Container",
  styles: _Container
});

const ContentWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "ContentWrapper",
  styles: _ContentWrapper
});

const TextSection = /*#__PURE__*/styled("div", null, {
  displayName: "TextSection",
  styles: _TextSection
});

const TitleWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "TitleWrapper",
  styles: _TitleWrapper
});

const IconWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "IconWrapper",
  styles: _IconWrapper
});

const Title = /*#__PURE__*/styled("p", null, {
  displayName: "Title",
  styles: _Title
});

const Description = /*#__PURE__*/styled("p", null, {
  displayName: "Description",
  styles: _Description
});

const ButtonWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "ButtonWrapper",
  styles: _ButtonWrapper
});

const StyledButton = /*#__PURE__*/styled(Button, null, {
  displayName: "StyledButton",
  styles: _StyledButton
});

/**
 * Podcast Library Ad 2 component that promotes the podcast library feature.
 * Displays as a clickable banner in the home feed linking to the podcast library.
 * Features a dark teal background with white text and a call-to-action button.
 *
 * This component is automatically tracked with impression watching.
 */
export const PodcastLibraryAd2: React.FC = () => {
  const impressionSource = 'podcast_lib.home.ad-2';

  return (
    <ImpressionWatcher active={true} source={impressionSource}>
      <Container href={routes.podcast_library_url()}>
        <ContentWrapper>
          <TextSection>
            <TitleWrapper>
              <IconWrapper>
                <Icon name="books_movies_and_music" size={24} />
              </IconWrapper>
              <Title>Discover podcast library</Title>
            </TitleWrapper>
            <Description>
              Listen to paper insights in minutes, not hours
            </Description>
          </TextSection>
          <ButtonWrapper>
            <StyledButton size="sm" iconRight="arrow_forward">
              Browse podcast library
            </StyledButton>
          </ButtonWrapper>
        </ContentWrapper>
      </Container>
    </ImpressionWatcher>
  );
};
